/* Base translations · Sign-off card — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): signOff. */
export const I18N_BASE_SIGN_OFF = {
  en: {
    signOff: {
      lockedTitle: "Engagement signed off · read-only",
      unlock: "Unlock",
      unlockTitle: "Unlock signed-off engagement",
      unlockDesc: "Unlocking re-enables all mutations. The previous signature hash and signatory are preserved in the reopen history, and this action is logged in the Audit Trail. You'll need to re-sign to freeze again.",
      unlockPh: "Reason for unlock (optional but recommended)",
      cancel: "Cancel",
      unlocking: "Unlocking…",
      unlockBtn: "Unlock engagement",
      signedBy: "Signed by",
      signedAt: "Signed at",
      integrity: "SHA-256 Integrity",
      dlBundle: "Download ZIP bundle",
      dlPdf: "Download combined PDF",
      workflowTitle: "Sign-off workflow",
      eqcSuffix: " · EQ review required",
      workflowDesc: "Sequential ISA 220 workflow: {chain}. Each stage must be signed by a user with the matching role. The Partner sign-off generates the tamper-evident bundle (SHA-256 hash) and, together with EQ reviewer when required, fully freezes the engagement.",
      chainNoEqc: "Preparer → Reviewer → Partner",
      chainEqc: "Preparer → Reviewer → Partner → EQ reviewer",
      blockedTitle: "Sign-off blocked — {plural} still unmapped",
      blockedDesc: "Every account with GL activity must have an FS mapping code before Partner sign-off — otherwise its balance is silently excluded from the statements. Framework: {fw}.",
      moreSuffix: " and {n} more",
      openMapping: "Open FS Mapping",
      eqrBlockedTitle: "EQ Review not yet complete — Partner sign-off blocked (ISQM 2.24(b), 27; ISA 220 (Revised).36(d))",
      eqrBlockedDesc: "Form 522(a)'s Overall conclusion must record {satisfactorily} before the auditor's report can be dated.",
      satisfactorilyBold: "Completed satisfactorily",
      currentValue: "Current value:",
      noConclusion: " No conclusion has been recorded yet.",
      open522a: "Open 522(a)",
      eqrOkTitle: "EQ Review complete — report-date gate satisfied (ISQM 2.24(b), 27; ISA 220 (Revised).36(d))",
      eqrSignedOffBy: "Signed off by",
      eqrConfirmed: "Reviewer confirmed the EQ review",
      eqrOnDate: " on {when}",
      eqrRecordedBy: " (recorded by {who})",
      significantMatters: "Significant matters:",
      stageSigned: "✓ signed",
      stageSigning: "Signing…",
      stagePartnerBlocked: "Mapping incomplete",
      stageSignAs: "Sign as {stage}",
      stageWaiting: "Waiting for {roles}",
      stagePending: "Pending previous stage",
      stageComplete: "{stage} sign-off complete",
      stageCompleteHash: "{stage} sign-off complete · integrity hash {hash}…",
      signoffFailed: "Sign-off failed",
      unlockSuccess: "Engagement unlocked — mutations enabled again",
      unlockFailed: "Unlock failed",
      lockedBanner: "Engagement signed off — read-only.",
      lockedBannerBy: "Signed by {name} on {when} ({zone}) · hash {hash}…",
      stagePreparer: "Preparer",
      stagePreparerHint: "Field work is complete and ready for review",
      stageReviewer: "Reviewer",
      stageReviewerHint: "Second-line review complete",
      stagePartner: "Partner",
      stagePartnerHint: "Final sign-off — freezes the engagement and generates the tamper-evident bundle",
      stageEqc: "EQ reviewer",
      stageEqcHint: "Engagement quality review (ISQM 1; ISA 220 (Revised).36)",
    },
  },
  ar: {
    signOff: {
      lockedTitle: "تم توقيع المهمة · للقراءة فقط",
      unlock: "فتح القفل",
      unlockTitle: "فتح قفل المهمة الموقّعة",
      unlockDesc: "يعيد فتح القفل تفعيل جميع التعديلات. يتم الاحتفاظ بتوقيع التوقيع السابق والموقّع في سجل إعادة الفتح، ويتم تسجيل هذا الإجراء في سجل التدقيق. ستحتاج إلى إعادة التوقيع لتجميدها مرة أخرى.",
      unlockPh: "سبب فتح القفل (اختياري ولكن يُوصى به)",
      cancel: "إلغاء",
      unlocking: "جاري فتح القفل…",
      unlockBtn: "فتح قفل المهمة",
      signedBy: "موقّعة بواسطة",
      signedAt: "موقّعة في",
      integrity: "سلامة SHA-256",
      dlBundle: "تحميل حزمة ZIP",
      dlPdf: "تحميل ملف PDF مجمّع",
      workflowTitle: "سير عمل التوقيع",
      eqcSuffix: " · مراجعة الجودة (EQ) مطلوبة",
      workflowDesc: "سير عمل تسلسلي وفق ISA 220: {chain}. يجب أن يوقع كل مرحلة مستخدم بالدور المطابق. توقيع الشريك يولّد الحزمة المقاومة للتلاعب (تجزئة SHA-256) ومع مراجع الجودة عند الحاجة يجمّد المهمة بالكامل.",
      chainNoEqc: "المُعدّ ← المراجع ← الشريك",
      chainEqc: "المُعدّ ← المراجع ← الشريك ← مراجع الجودة",
      blockedTitle: "التوقيع محظور — {plural} لا تزال غير مربوطة",
      blockedDesc: "يجب أن يكون لكل حساب به حركة أستاذ رمز ربط بالقوائم المالية قبل توقيع الشريك — وإلا يُستبعد رصيده بصمت من القوائم. الإطار: {fw}.",
      moreSuffix: " و {n} أخرى",
      openMapping: "فتح ربط القوائم المالية",
      eqrBlockedTitle: "مراجعة الجودة لم تكتمل بعد — توقيع الشريك محظور (ISQM 2.24(b), 27; ISA 220 (Revised).36(d))",
      eqrBlockedDesc: "يجب أن يسجّل الاستنتاج العام في النموذج 522(أ) {satisfactorily} قبل إمكانية تأريخ تقرير المدقق.",
      satisfactorilyBold: "اكتملت بشكل مُرضٍ",
      currentValue: "القيمة الحالية:",
      noConclusion: " لم يُسجَّل استنتاج بعد.",
      open522a: "فتح 522(أ)",
      eqrOkTitle: "مراجعة الجودة مكتملة — بوابة تاريخ التقرير مستوفاة (ISQM 2.24(b), 27; ISA 220 (Revised).36(d))",
      eqrSignedOffBy: "موقّعة بواسطة",
      eqrConfirmed: "أكد المراجع مراجعة الجودة",
      eqrOnDate: " بتاريخ {when}",
      eqrRecordedBy: " (سجّلت بواسطة {who})",
      significantMatters: "الأمور المهمة:",
      stageSigned: "✓ موقّع",
      stageSigning: "جاري التوقيع…",
      stagePartnerBlocked: "الربط غير مكتمل",
      stageSignAs: "وقّع كـ {stage}",
      stageWaiting: "بانتظار {roles}",
      stagePending: "بانتظار المرحلة السابقة",
      stageComplete: "اكتمل توقيع {stage}",
      stageCompleteHash: "اكتمل توقيع {stage} · تجزئة السلامة {hash}…",
      signoffFailed: "فشل التوقيع",
      unlockSuccess: "تم فتح قفل المهمة — أُعيد تفعيل التعديلات",
      unlockFailed: "فشل فتح القفل",
      lockedBanner: "تم توقيع المهمة — للقراءة فقط.",
      lockedBannerBy: "موقّعة بواسطة {name} في {when} ({zone}) · تجزئة {hash}…",
      stagePreparer: "المُعدّ",
      stagePreparerHint: "اكتمل العمل الميداني وجاهز للمراجعة",
      stageReviewer: "المراجع",
      stageReviewerHint: "اكتملت المراجعة الثانوية",
      stagePartner: "الشريك",
      stagePartnerHint: "التوقيع النهائي — يجمّد المهمة ويولّد الحزمة المقاومة للتلاعب",
      stageEqc: "مراجع جودة الارتباط",   // STEP 7b · D3: was "EQ reviewer" (English) on the Arabic sign-off card

      stageEqcHint: "مراجعة جودة المهمة (ISQM 1؛ ISA 220 (Revised).36)",
    },
  },
};

export default I18N_BASE_SIGN_OFF;
